import { 
    initSlider, 
    videoLazyLoad, 
    revealOnAction 
} from '../../_modules/helpers'


export function initVideos() {

    let sliderDestructor = () => {}
    const videosRoot = document.getElementById('videos')
    if (!videosRoot) return

    const videos = videosRoot.querySelectorAll('video')
    videos.forEach((video) => {
        const videoSrc = video.dataset.video
        const posterSrc = video.dataset.poster

        if (!videoSrc) return

        const videoLoadCallback = () => {
            const play = video.closest('div').querySelector('button')
            play.addEventListener('click', () => {
                video.play()
                play.hidden = true
                video.controls = true
            })

            sliderDestructor()
            sliderDestructor = initSlider(videosRoot)
        }

        const disableOtherVideos = () => {
            videos.forEach(anotherVideo => {
                if (anotherVideo === video) return
                if (anotherVideo.paused) return
                anotherVideo.pause()
            })
        }

        video.addEventListener('play', disableOtherVideos)

        videoLazyLoad({
            videoElement: video,
            videoSrc,
            rootMargin: '100px 1000px 100px 1000px',
            callback: videoLoadCallback
        })

        revealOnAction(() => video.poster = posterSrc)
    })
}
